import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import edit from "../images/Icon-Edit.svg";
import cross from "../images/cross.png";
import close from "../images/close.png";
import NoteModal from "./Modals/NoteModal";
import Modal from "./Modals/Modal";
import moment from "moment";
import SynopsEditModal from "./Modals/SynopsEditModal";
import { keyContext } from "../components/KeyContext";
import EmojiPicker from "emoji-picker-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function Synopsis({ arrTypes, filmdata }) {
  const [filmSynopsValue, setFilmSynopsValue] = useState("");
  const [arrSynopsValue, setArrSynopsValue] = useState("");
  const [contentPaste, setContentPaste] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [plainTextMode, setPlainTextMode] = useState(true);

  const [data, setData] = useState(filmdata);
  const [adding_save_succes, setAdding_save_success] = useState(false);

  const [showNewAddings, setSetshowNewAddings] = useState(false);
  const arr_types = Object.assign({}, [arrTypes])[0];

  const key = sessionStorage.getItem("key");
  const [arrtypeselect, setArrtypeselect] = useState(false);
  const [arrtypeName, setArrtypeName] = useState([]);
  const [selectedArrtype, setSetselectedArrtype] = useState("");
  const [selectedArrSynops, setSelectedArrSynops] = useState("");
  const [arrChangeClk, setArrChangeClk] = useState(false);

  const [filmSynopsClk, setFilmSynopsClk] = useState(false);
  const [arrSynopsClk, setArrSynopsClk] = useState(false);
  // const [arrSynops, setArrSynops] = useState('');
  const [filmSynopsInput, setFilmSynopsInput] = useState("");
  const [arrSynopsInput, setArrSynopsInput] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorNo, setErrorNo] = useState();
  const [errorText, setErrorText] = useState();
  const [allAddings, setAllAddings] = useState(data.addings);
  const [addingWithArr0, setAddingWithArr0] = useState();
  const [filmSynops, setFilmSynops] = useState("");
  const fullDateFormat = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");


  useEffect(() => {
    setAllAddings(data.addings);
  }, [data, showNewAddings]);

  useEffect(() => {
    addingWithArr0 &&
      addingWithArr0.addSynopsis &&
      setFilmSynopsValue(addingWithArr0.addSynopsis);
  }, [addingWithArr0]);

  const addEmoji = (emojiData) => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection(true);

    quill.insertText(range.index, emojiData.emoji);
    quill.setSelection(range.index + emojiData.emoji.length);
  };

  // removing duplicates if there are any
  data.addings = [
    ...new Map(data.addings.map((item) => [item.adding.addNo, item])).values(),
  ];

  // ----search functionality------
  const [q, setQ] = useState(""); // search word for arrtypes
  const [b, setB] = useState(""); // search word for tickettypes
  const [searchParam] = useState(["Name"]);
  const [filterParam, setFilterParam] = useState(["Name"]);
  const leftMargin = document
    .getElementById("filmedit")
    .getBoundingClientRect().x;
  const orgID = sessionStorage.getItem("orgID");
  let org = sessionStorage.getItem("filmOrg")
    ? sessionStorage.getItem("filmOrg")
    : sessionStorage.getItem("default-filmID");
  const orgNo = org && org.split(" ")[org.split(" ").length - 1];

  // --------------ERROR MODAL ----------------
  function ErrorModal({ shown, children, errorText, errorNo }) {
    function handleOkBtn() {
      setShowErrorModal(false);
      setFilmSynopsClk(false);
    }

    return shown ? (
      <div
        style={{
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          top: "69px",
          left: leftMargin,
          width: "1440px",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 100,
          overflowY: "auto",
          height: "100%",
        }}
      >
        {children}

        <div
          style={{
            border: "1px solid white",
            width: "500px",
            height: "300px",
            backgroundColor: "white",
            padding: "20px",
            marginTop: "20px",
            borderRadius: "4px",
            position: "absolute",
            top: "20%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <p style={{ fontWeight: 900 }}>Result : {errorNo}</p>
          <p style={{ fontWeight: 900 }}>ErrorDescription:</p>
          <p
            style={{
              height: "60%",
              overflow: "auto",
              border: "1px solid #dee0e3",
              borderRadius: "4px",
              padding: "5px",
              marginTop: "-15px",
            }}
          >
            {" "}
            {errorText}
          </p>

          <button
            onClick={handleOkBtn}
            style={{
              backgroundColor: "#982f2f",
              color: "white",
              padding: "5px",
              width: "100px",
              borderRadius: "5px",
            }}
          >
            Ok
          </button>
        </div>
      </div>
    ) : (
      ""
    );
  }

  function search(items) {
    return items.filter((item) => {
      if (filterParam == "Name") {
        return searchParam.some((newItem) => {
          return (
            item[newItem] &&
            item[newItem]
              .toString()
              .toLowerCase()
              .indexOf(q || b.toLowerCase()) > -1
          );
        });
      }
    });
  }

  function isEmpty(obj) {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false;
      }
    }
    return true;
  }

  let addings_arr; //addings_arr formation

  if (data.addings) {
    addings_arr =
      allAddings &&
      allAddings?.map((ad) => {
        if (ad.adding.addArrTypeNo !== 0) {
          let arr;
          arr_types.map((ar) => {
            if (ar.No === ad.adding.addArrTypeNo) {
              arr = {
                No: ad.adding.addArrTypeNo,
                synops: ad.adding.addSynopsis,
                Name: ar.Name,
              };

              return arr;
            }
          });
          return arr;
        }
      });
  } else addings_arr = [];
  addings_arr = addings_arr?.filter(function (elm) {
    return elm !== undefined;
  });

  const [selectedArrObj, setSelectedArrObj] = useState(
    data.addings?.length ? addings_arr[0] : {},
  );

  const [arrtypechange, setarrtypechange] = useState(false);

  function handleArrtypeChange(e) {
    setQ(e.target.value.toLowerCase());
    setarrtypechange(true);
    setArrtypeselect(false);
  }
  // following function runs when new arrtype selected from search
  function selectArrType(e) {
    let item = e.target.innerText;
    setQ(e.target.innerText);
    setArrtypeselect(true);
    setArrtypeName((arrtypeName) => [...arrtypeName, item]);

    setArrSynopsClk(true);
    setArrSynopsValue("");
    setSelectedArrObj("");
  }

  function handleArrtypeUnselect() {
    setQ("");
  }

  // function runs when existing arrtype is changed
  function handleArr(arr) {
    setArrChangeClk(true);
    setSetselectedArrtype(arr.Name);
    setSelectedArrSynops(arr.synops);
    setSelectedArrObj(arr);
  }

  useEffect(() => {
    //  if(data.addings?.length) {
    allAddings &&
      allAddings.map((ad) => {
        if (ad.adding.addArrTypeNo === 0) {
          setAddingWithArr0(ad.adding);
          setFilmSynops(ad.adding.addSynopsis);
        }
      });
    // }
  }, [data, allAddings, arr_types]);

  function changeFilmSynops() {
    setFilmSynopsClk(true);
  }

  function deleteFilmSynops() {
    setFilmSynopsClk(false);

    if (addingWithArr0) {
      let deleting_obj = Object.assign({}, addingWithArr0);
      deleting_obj.addCreateDate = fullDateFormat;
      deleting_obj.addEditDate = fullDateFormat;
      deleting_obj.addTitleReplace = "";
      addingDelete(deleting_obj, filmSynops);
    }

    setContentPaste(false);
  }

  // function encodes object to base64 string
  function encodeBase64(str) {
    return window.btoa(
      new TextEncoder()
        .encode(str)
        .reduce((data, byte) => data + String.fromCharCode(byte), ""),
    );
  }

  function saveFilmSynops() {
    if (filmSynopsValue) {
      setFilmSynopsClk(false);

      if (addingWithArr0) {
        let adding_obj = Object.assign({}, addingWithArr0);
        adding_obj.addSynopsis = filmSynopsValue;
        adding_obj.addCreateDate = moment(
          adding_obj.addCreateDate,
          "DD-MM-YYYY HH:mm:ss",
        ).format("YYYY-MM-DD HH:mm:ss");
        adding_obj.addEditDate = moment(
          adding_obj.addEditDate,
          "DD-MM-YYYY HH:mm:ss",
        ).format("YYYY-MM-DD HH:mm:ss");
        adding_obj.addTitleReplace = "";
        console.log(adding_obj, "adding obj");
        addingSave(adding_obj);
      } else {
        let adding_obj = {
          addArrTypeNo: 0,
          addCreateDate: fullDateFormat,
          addCreateLoginNo: 4,
          addEditDate: fullDateFormat,
          addEditLoginNo: orgID,
          addEnabled: 1,
          addNo: 0,
          addOrgNo: orgNo,
          addSynopsis: filmSynopsValue,
          addSynopsisReplace: 0,
          addSysNo: 3,
          addTitleReplace: "",
          addWebMovieNo: data._no,
        };

        addingSave(adding_obj);
      }
    }
    setContentPaste(false);
  }

  function addingSave(adding_data, newarr) {
    fetch(
      `https://biograf.ebillet.dk/systemnative/report.asmx/man_adding_save`,
      {
        method: "POST",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        },

        body: `Key=${key}&addingdata=${encodeURIComponent(encodeBase64(JSON.stringify(adding_data)))}`,
      },
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.Result !== 1) {
          setShowErrorModal(true);
          setErrorNo(result.Result);
          setErrorText(result.ErrorDescription);
          //document.getElementById('filmsynops').innerText = filmSynops
        } else {
          setAdding_save_success(true);
          // if adding already exists then removing it
          const arr_exist = data.addings.filter((ar) => {
            return ar.adding.addArrTypeNo === result.addArrTypeNo;
          });
          if (arr_exist) {
            data.addings = data.addings.filter((ar) => {
              return adding_data.addArrTypeNo !== ar.adding.addArrTypeNo;
            });
          }

          // pushing new result ad adding in data.addings
          data.addings.push({ adding: result });

          setAllAddings(data.addings);
          newarr && addings_arr.push(newarr);

          newarr && setSelectedArrObj(newarr);
          //  setnewAdding(newarr)
        }
      });
    setArrSynopsValue("");
    setFilmSynopsValue("");
  }

  function addingDelete(obj, filmSynops) {
    fetch(
      `https://biograf.ebillet.dk/systemnative/report.asmx/man_adding_delete`,
      {
        method: "POST",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          "Content-Type": "application/x-www-form-urlencoded",
        },

        body: `Key=${key}&addingdata=${encodeURIComponent(encodeBase64(JSON.stringify(obj)))}`,
      },
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.Result !== 1) {
          setShowErrorModal(true);
          setErrorNo(result.Result);
          setErrorText(result.ErrorDescription);
        } else {
          setAdding_save_success(true);

          data.addings = data.addings.filter((ar) => {
            return obj.addArrTypeNo !== ar.adding.addArrTypeNo;
          });
          addings_arr = addings_arr.filter((ar) => {
            return ar.No !== obj.addArrTypeNo;
          });
          // setarradding(addings_arr)
          setSetshowNewAddings(true);

          //filmSynops ? document.getElementById('filmsynops').innerText = '' : document.getElementById('filmsynops').innerText = '';
          if (filmSynops) {
            document.getElementById("filmsynops").innerText = "";
            setFilmSynops("");
          }
          filmSynops && setAddingWithArr0("");
          filmSynops && setFilmSynopsValue("");
          // setSelectedArrObj(addings_arr[0])
          // obj_select = addings_arr[0]
          setAllAddings(data.addings);

          setSelectedArrObj(addings_arr.length > 0 ? addings_arr[0] : {});
        }
      });
  }

  function changeArrSynops() {
    setArrSynopsClk(true);
  }

  function handleArrSynops(e) {
    setArrSynopsInput(e.target.innerText);
  }

  //  useEffect(() => {
  //   if(arrSynopsClk === true || arrtypeselect === true) {
  //     // document.getElementById('arrsynops').focus()
  //   }
  //  }, [arrSynopsClk,arrtypeselect]);
  const [deleteObj, setDeleteObj] = useState([{ No: "", Name: "" }]);

  // when creating new adding for arrtypes from search
  function cancelNewAdding() {
    setQ("");
    setArrSynopsClk(false);
    setSelectedArrObj(data.addings?.length ? addings_arr[0] : {});
    setArrtypeselect(false);
    setArrSynopsValue("");
    setContentPaste(false);
  }

  // when saving new adding from arrtypes from search
  function saveNewAdding() {
    //  setsavenewAdding(true)

    if (arrSynopsValue) {
      let array = arr_types.filter((ar) => {
        return ar.Name == q;
      })[0];

      let newarr = array && Object.assign(array, { synops: arrSynopsValue });

      setArrSynopsClk(false);
      setArrtypeselect(false);
      setQ("");

      let adding_obj = {
        addArrTypeNo: newarr.No,
        addCreateDate: fullDateFormat,
        addCreateLoginNo: orgID,
        addEditDate: fullDateFormat,
        addEditLoginNo: orgID,
        addEnabled: 1,
        addNo: 0,
        addOrgNo: orgNo,
        addSynopsis: arrSynopsValue,
        addSynopsisReplace: 0,
        addSysNo: 3,
        addTitleReplace: "",
        addWebMovieNo: data._no,
      };

      addingSave(adding_obj, newarr);
    }
    setContentPaste(false);
  }

  function deleteAdding(arr) {
    const del = data.addings.filter((ar) => {
      return ar.adding.addArrTypeNo === arr.No;
    })[0].adding;

    let deleting_obj = {
      addArrTypeNo: del.addArrTypeNo,
      addCreateDate: fullDateFormat,
      addCreateLoginNo: 4,
      addEditDate: fullDateFormat,
      addEditLoginNo: orgID,
      addEnabled: 1,
      addNo: del.addNo,
      addOrgNo: orgNo,
      addSynopsis: del.addSynopsis,
      addSynopsisReplace: 0,
      addSysNo: 3,
      addTitleReplace: "",
      addWebMovieNo: data._no,
    };

    addingDelete(deleting_obj);
  }

  function cancelArrSynopsEdit() {
    setArrSynopsClk(false);

    setQ("");

    setArrSynopsValue(selectedArrObj.synops);

    document.getElementById("arrsynops").innerText = selectedArrObj.synops;

    // if selected arr object .No is not among arrTypeNo in addings array then remove the object from addings_arr
    addings_arr = addings_arr.filter((arr) => selectedArrObj.No === arr.No);
    setDeleteObj(addings_arr);
    setContentPaste(false);
  }

  function saveArrSynopsEdit() {
    setArrSynopsClk(false);
    // setArrtypeselect(false)
    let selectedArrNo = selectedArrObj.No;

    let newarr = Object.assign(selectedArrObj, { synops: arrSynopsValue });

    let adding_obj;
    allAddings &&
      allAddings.map((ad) => {
        if (ad.adding.addArrTypeNo === selectedArrNo) {
          adding_obj = Object.assign({}, ad.adding);
        }
        return adding_obj;
      });
    if (adding_obj) {
      adding_obj.addSynopsis = arrSynopsValue;
      adding_obj.addTitleReplace = "";
      adding_obj.addCreateDate = moment(
        adding_obj.addCreateDate,
        "DD-MM-YYYY HH:mm:ss",
      ).format("YYYY-MM-DD HH:mm:ss");
      adding_obj.addEditDate = moment(
        adding_obj.addEditDate,
        "DD-MM-YYYY HH:mm:ss",
      ).format("YYYY-MM-DD HH:mm:ss");

      addingSave(adding_obj);
    } else {
      let obj = {
        addArrTypeNo: selectedArrNo,
        addCreateDate: fullDateFormat,
        addCreateLoginNo: 4,
        addEditDate: fullDateFormat,
        addEditLoginNo: orgID,
        addEnabled: 1,
        addNo: 0,
        addOrgNo: orgNo,
        addSynopsis: arrSynopsValue,
        addSynopsisReplace: 0,
        addSysNo: 3,
        addTitleReplace: "",
        addWebMovieNo: data._no,
      };

      addingSave(obj);
    }

    setContentPaste(false);
  }

  // the text editor must show the synopsis of selected adding object
  const quillRef = useRef(null);

  useEffect(() => {
    selectedArrObj && setArrSynopsValue(selectedArrObj.synops);
  }, [selectedArrObj]);

  const handleChange = (content, delta, source, editor) => {
    if (plainTextMode && contentPaste) {
      setFilmSynopsValue(editor.getText());
    } else setFilmSynopsValue(content);
  };

  const handleChangeArrTypes = (content, delta, source, editor) => {
    if (plainTextMode && contentPaste) {
      setArrSynopsValue(editor.getText().replace(/<\/?p>/g, ""));
    } else setArrSynopsValue(content);
  };

  function handlePaste() {
    setContentPaste(true);
  }

  const togglePlainText = (e) => {
    const checked = e.target.checked;
    setPlainTextMode(checked);

    if (checked) {
      setFilmSynopsValue(
        document.getElementsByClassName("ql-editor")[0].innerText,
      );
    }
  };

  const togglePlainTextArrTypes = (e) => {
    const checked = e.target.checked;
    setPlainTextMode(checked);

    if (checked) {
      setArrSynopsValue(
        document.getElementsByClassName("ql-editor")[0].innerText,
      );
    }
  };


  return (
    <main style={{ width: "510px" }}>
      <ErrorModal
        shown={showErrorModal}
        errorNo={errorNo}
        errorText={errorText}
      />
      <SynopsEditModal
        shown={filmSynopsClk || arrSynopsClk}
        leftMargin={leftMargin}
      />

      <div
        style={{
          position: "relative",
          zIndex: filmSynopsClk === true ? 15 : "",
        }}
      >
        <p className="grunddata-title">Kort tekst inden synopsis</p>

        <div
          style={{
            width: "100%",
            border: filmSynopsClk === true ? "none" : "",
            height: "auto",
            minHeight: "40px",
          }}
        >
          {filmSynopsClk === true ? (
            <>
              <button
                style={{
                  float: "right",
                  backgroundColor: "#982f2f",
                  color: "white",
                  padding: "3px 10px",
                  position: "absolute",
                  right: "60px",
                  top: "-3px",
                  borderRadius: "3px",
                }}
                onClick={deleteFilmSynops}
              >
                Slet
              </button>
              <button
                style={{
                  float: "right",
                  backgroundColor: "#982f2f",
                  color: "white",
                  padding: "3px 10px",
                  position: "absolute",
                  right: 0,
                  top: "-3px",
                  borderRadius: "3px",
                }}
                onClick={saveFilmSynops}
              >
                Gem
              </button>
              <label
                style={{
                  position: "absolute",
                  top: "-3px",
                  backgroundColor: "#982f2f",
                  color: "white",
                  padding: "3px 10px",
                  right: "115px",
                }}
              >
                <input
                  type="checkbox"
                  style={{ marginRight: "5px" }}
                  checked={plainTextMode}
                  onChange={togglePlainText}
                />
                indsæt som ren tekst
              </label>
            </>
          ) : (
            ""
          )}
          {filmSynopsClk === true ? (
            <div style={{ backgroundColor: "white" }} onPaste={handlePaste}>
              <button onClick={() => setShowEmoji(!showEmoji)}>😊 Emoji</button>

              {showEmoji && <EmojiPicker onEmojiClick={addEmoji} />}
              <ReactQuill
                theme="snow"
                value={filmSynopsValue}
                ref={quillRef}
                onChange={handleChange}
              />
            </div>
          ) : (
            <pre
              className="grunddata-subtitle"
              id="filmsynops"
              style={{
                fontWeight: 400,
                whiteSpace: "pre-line",
                fontFamily: "lato",
                maxHeight: "600px",
                border: "1px solid #dee0e3",
                minHeight: "40px",
              }}
              dangerouslySetInnerHTML={{
                __html: decodeURIComponent(filmSynops),
              }}
            ></pre>
          )}
        </div>
        <img
          onClick={changeFilmSynops}
          style={{
            position: "absolute",
            top: "28px",
            right: "-28px",
            display: filmSynopsClk === true ? "none" : "",
            cursor: "pointer",
          }}
          src={edit}
          alt="edit"
        />
      </div>
      <br />
      <br />
      <section
        className=""
        style={{
          width: "505px",
          borderRadius: "4px",
          backgroundColor: "#f7f7f7",
          padding: "20px",
          height: arrtypeselect === true ? "250px" : "",
        }}
      >
        <div style={{ position: "relative" }}>
          <p style={{ color: "#101010", fontWeight: 700, marginBottom: "5px" }}>
            Indsæt valgfri ekstra-tekst til særforestillinger
          </p>
          <p style={{ color: "#101010", fontWeight: 400 }}>
            Teksten indsættes først i synopsis
          </p>
          <p
            style={{
              fontWeight: "bold",
              letterSpacing: "0.32px",
              height: "10px",
            }}
          >
            {" "}
            Vælg Forestillingtype:
          </p>
          <input
            name=""
            id="arr-input"
            value={q ? q : ""}
            onChange={(e) => handleArrtypeChange(e)}
            style={{
              width: "100%",
              paddingLeft: "30px",
              height: "40px",
              paddingBottom: "6px",
            }}
          />
          <div
            style={{
              borderLeft:
                q && search(arr_types) && arrtypeselect === false
                  ? "1px solid #8b8b8b"
                  : "1px",
              borderRight:
                q && search(arr_types) && arrtypeselect === false
                  ? "1px solid #8b8b8b"
                  : "1px",
              borderBottom:
                q && search(arr_types) && arrtypeselect === false
                  ? "1px solid #8b8b8b"
                  : "1px",
              backgroundColor: "white",
              position: "absolute",
              right: "74px",
              left: 0,
              zIndex: 11,
              width: "100%",
            }}
          >
            {q &&
              search(arr_types).map((item) => (
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    paddingLeft: "10px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => selectArrType(e, item)}
                >
                  {item.Name}
                </p>
              ))}
          </div>

          <span style={{ position: "absolute", left: "8px", top: "100px" }}>
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.8709 15.4795L11.8948 11.5157C12.9783 10.1946 13.5111 8.50888 13.3828 6.8072C13.2546 5.10553 12.4751 3.51809 11.2058 2.37324C9.93639 1.22839 8.27418 0.613723 6.56295 0.656377C4.85172 0.699031 3.2224 1.39574 2.012 2.6024C0.801605 3.80906 0.102734 5.43335 0.059948 7.13929C0.017162 8.84523 0.633734 10.5023 1.78213 11.7678C2.93053 13.0332 4.52288 13.8102 6.22984 13.9381C7.93679 14.0659 9.62773 13.5348 10.9529 12.4547L14.929 16.4185C15.0546 16.5394 15.2229 16.6064 15.3975 16.6048C15.5722 16.6033 15.7393 16.5335 15.8628 16.4104C15.9863 16.2872 16.0563 16.1207 16.0578 15.9466C16.0594 15.7725 15.9922 15.6047 15.8709 15.4795ZM6.74038 12.6287C5.68641 12.6287 4.65611 12.3171 3.77977 11.7333C2.90342 11.1496 2.2204 10.3199 1.81706 9.34917C1.41373 8.37844 1.3082 7.31027 1.51382 6.27975C1.71943 5.24923 2.22697 4.30263 2.97224 3.55967C3.7175 2.8167 4.66703 2.31074 5.70075 2.10575C6.73446 1.90077 7.80594 2.00597 8.77968 2.40806C9.75342 2.81015 10.5857 3.49107 11.1712 4.3647C11.7568 5.23834 12.0693 6.26545 12.0693 7.31616C12.0677 8.72464 11.5058 10.075 10.5068 11.0709C9.50773 12.0669 8.15321 12.6271 6.74038 12.6287Z"
                fill="#323232"
              />
            </svg>
            {/* <img src={searchimg} alt='search' height='20px'/> */}
          </span>
          <span style={{ position: "absolute", right: "15px", top: "100px" }}>
            {q && <img src={cross} alt="" onClick={handleArrtypeUnselect} />}
          </span>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}>
          {addings_arr.length > 0
            ? addings_arr.map((arr, key) => {
                if (arr && selectedArrObj) {
                  return (
                    <div
                      id={key}
                      style={{
                        padding: "0px 7px",
                        marginRight: "20px",
                        textAlign: "center",
                        marginTop: "10px",
                        height: "29px",
                        border: "1px solid  #dee0e3",
                        backgroundColor:
                          selectedArrObj.Name == arr.Name ? "#982f2f" : "white",
                        borderRadius: "3px",
                        textDecoration: "underline",
                        color: selectedArrObj.Name == arr.Name ? "white" : "",
                        lineHeight: "25px",
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <p
                        style={{ height: "100%", lineHeight: "22px" }}
                        onClick={() => handleArr(arr)}
                      >
                        {arr.Name}{" "}
                      </p>
                      <span
                        onClick={() => deleteAdding(arr)}
                        style={{
                          marginLeft: "5px",
                          cursor: "pointer",
                          marginTop: "-2px",
                        }}
                      >
                        {selectedArrObj.Name == arr.Name ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                          >
                            <path
                              d="M6.98449 7.07004L6.55596 7.49857C6.43762 7.61691 6.24576 7.61691 6.12743 7.49857L3.77051 5.14165L1.41359 7.49857C1.29525 7.61691 1.10339 7.61691 0.985057 7.49857L0.556526 7.07004C0.43819 6.95171 0.43819 6.75985 0.556526 6.64151L2.91345 4.28459L0.556526 1.92767C0.43819 1.80933 0.43819 1.61747 0.556526 1.49914L0.985056 1.07061C1.10339 0.952272 1.29525 0.952272 1.41359 1.07061L3.77051 3.42753L6.12743 1.07061C6.24576 0.952272 6.43762 0.952272 6.55596 1.07061L6.98449 1.49914C7.10283 1.61747 7.10283 1.80933 6.98449 1.92767L4.62757 4.28459L6.98449 6.64151C7.10283 6.75985 7.10283 6.95171 6.98449 7.07004Z"
                              fill="white"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                          >
                            <path
                              d="M6.98449 7.07004L6.55596 7.49857C6.43762 7.61691 6.24576 7.61691 6.12743 7.49857L3.77051 5.14165L1.41359 7.49857C1.29525 7.61691 1.10339 7.61691 0.985057 7.49857L0.556526 7.07004C0.43819 6.95171 0.43819 6.75985 0.556526 6.64151L2.91345 4.28459L0.556526 1.92767C0.43819 1.80933 0.43819 1.61747 0.556526 1.49914L0.985056 1.07061C1.10339 0.952272 1.29525 0.952272 1.41359 1.07061L3.77051 3.42753L6.12743 1.07061C6.24576 0.952272 6.43762 0.952272 6.55596 1.07061L6.98449 1.49914C7.10283 1.61747 7.10283 1.80933 6.98449 1.92767L4.62757 4.28459L6.98449 6.64151C7.10283 6.75985 7.10283 6.95171 6.98449 7.07004Z"
                              fill="#46484C"
                            />
                          </svg>
                        )}
                      </span>
                    </div>
                  );
                }
              })
            : ""}
        </div>
        {arrtypeselect === true && (
          <div style={{ zIndex: "15", position: "relative", top: "35px" }}>
            <div style={{ backgroundColor: "white" }} onPaste={handlePaste}>
              <ReactQuill
                theme="snow"
                ref={quillRef}
                value={arrSynopsValue}
                onChange={handleChangeArrTypes}
              />
            </div>
            <button
              onClick={cancelNewAdding}
              style={{
                height: "30px",
                right: "55px",
                top: "-30px",
                position: "absolute",
                backgroundColor: "#982f2f",
                color: "white",
              }}
            >
              Slet
            </button>
            <button
              onClick={saveNewAdding}
              style={{
                height: "30px",
                right: "5px",
                top: "-30px",
                position: "absolute",
                backgroundColor: "#982f2f",
                color: "white",
              }}
            >
              Gem
            </button>
            <label
              style={{
                position: "absolute",
                top: "-30px",
                backgroundColor: "#982f2f",
                color: "white",
                padding: "3px 10px",
                right: "100px",
              }}
            >
              <input
                type="checkbox"
                style={{ marginRight: "5px" }}
                checked={plainTextMode}
                onChange={togglePlainTextArrTypes}
              />{" "}
              indsæt som ren tekst{" "}
            </label>
          </div>
        )}

        {addings_arr.length > 0 &&
          addings_arr.map((arr, key) => {
            if (arr && arr.Name === selectedArrObj.Name) {
              return (
                <div className="addingTextContainer" id={key}>
                  <div style={{ marginTop: "30px", color: "#101010" }}>
                    <p style={{ fontWeight: 700, marginBottom: "-5px" }}>
                      For "{selectedArrObj.Name}":
                    </p>
                    <span style={{ fontWeight: 400 }}>
                      Vis denne tekst inden synopsen
                    </span>
                  </div>
                  <div
                    style={{
                      marginTop: "15px",
                      position: "relative",
                      zIndex: arrSynopsClk === true ? 15 : "",
                    }}
                  >
                    <div
                      className="gruddata-title-div"
                      style={{
                        width: "427px",
                        height: "auto",
                        minHeight: "40px",
                        backgroundColor: arrSynopsClk === true ? "white" : "",
                      }}
                    >
                      {arrSynopsClk === true ? (
                        <>
                          <button
                            style={{
                              float: "right",
                              backgroundColor: "#982f2f",
                              color: "white",
                              padding: "3px 10px",
                              position: "absolute",
                              right: "100px",
                              top: "-32px",
                              borderRadius: "3px",
                            }}
                            onClick={cancelArrSynopsEdit}
                          >
                            Fortryd
                          </button>
                          <button
                            style={{
                              float: "right",
                              backgroundColor: "#982f2f",
                              color: "white",
                              padding: "3px 10px",
                              position: "absolute",
                              right: "38px",
                              top: "-32px",
                              borderRadius: "3px",
                            }}
                            onClick={saveArrSynopsEdit}
                          >
                            Gem
                          </button>
                          <label
                            style={{
                              position: "absolute",
                              top: "-31px",
                              backgroundColor: "#982f2f",
                              color: "white",
                              padding: "3px 10px",
                              right: "178px",
                            }}
                          >
                            <input
                              type="checkbox"
                              style={{ marginRight: "5px" }}
                              checked={plainTextMode}
                              onChange={togglePlainTextArrTypes}
                            />
                            indsæt som ren tekst
                          </label>
                        </>
                      ) : (
                        ""
                      )}
                      {arrSynopsClk === true ? (
                        <div
                          style={{ backgroundColor: "white" }}
                          onPaste={handlePaste}
                        >
                          <ReactQuill
                            theme="snow"
                            value={arrSynopsValue}
                            ref={quillRef}
                            onChange={handleChangeArrTypes}
                          />
                        </div>
                      ) : (
                        <div
                          id="arrsynops"
                          dangerouslySetInnerHTML={{
                            __html: selectedArrObj.synops,
                          }}
                          className="grunddata-subtitle"
                          style={{ margin: "5px", padding: 0 }}
                        ></div>
                      )}
                    </div>

                    <span
                      onClick={changeArrSynops}
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.6 15.0391L4 19.9991L8.96 18.3991L5.6 15.0391Z"
                          fill="#46484C"
                        />
                        <path
                          d="M6.72363 13.8906L14.53 6.08431L17.924 9.47837L10.1177 17.2847L6.72363 13.8906Z"
                          fill="#46484C"
                        />
                        <path
                          d="M19.7602 6.48L17.5202 4.24C17.2002 3.92 16.7202 3.92 16.4002 4.24L15.6802 4.96L19.0402 8.32L19.7602 7.6C20.0802 7.28 20.0802 6.8 19.7602 6.48Z"
                          fill="#46484C"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              );
            }
          })}
      </section>

      <div style={{ position: "relative", marginTop: "50px" }}>
        <p className="grunddata-title">Synopis</p>
        <div
          style={{
            width: "100%",
            height: isEmpty(data.synopsis) === false ? "auto" : "40px",
          }}
        >
          <pre
            dangerouslySetInnerHTML={{
              __html: isEmpty(data.synopsis) === false ? data.synopsis : "",
            }}
            className="grunddata-subtitle"
            style={{
              fontWeight: 400,
              whiteSpace: "pre-line",
              fontFamily: "lato",
              maxHeight: "600px",
              border: "1px solid #dee0e3",
              minHeight: "40px",
            }}
          ></pre>
        </div>
        {/* <img style={{position:'absolute',top:'28px',right:'-28px'}} src={edit} alt='edit' /> */}
      </div>
    </main>
  );
}

export default Synopsis;
